import api from '@/api/_imagerieCliches'

const types = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf']
function batchKey() {
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
    return [hex.slice(0,8),hex.slice(8,12),hex.slice(12,16),hex.slice(16,20),hex.slice(20)].join('-')
}
export default {
    name: 'ImagerieCliches',
    props: { examenId: { type: Number, required: true }, dossier: { type: Boolean, default: false } },
    data: () => ({
        files: [], removed: [], selected: [], canEdit: false, loading: false, busy: false,
        loadError: '', actionError: '', message: '', key: '', revision: 0, previewRevision: 0,
        preview: null, previewBusy: false, zoom: 1, removing: null, reason: ''
    }),
    watch: { examenId: { immediate: true, handler() { this.load() } } },
    beforeDestroy() { this.revision++; this.closePreview() },
    methods: {
        apply(data) { this.files = data.files; this.removed = data.removed; this.canEdit = data.can_edit },
        async load() {
            const revision = ++this.revision
            this.closePreview(); this.files = []; this.removed = []; this.canEdit = false
            this.selected = []; this.key = ''; this.removing = null; this.reason = ''
            this.actionError = ''; this.loadError = ''; this.message = ''; this.busy = false
            if (!this.examenId) return
            this.loading = true
            try { const data = await api.list(this.examenId, this.dossier); if (revision === this.revision) this.apply(data) }
            catch (_) { if (revision === this.revision) this.loadError = 'Impossible de charger les clichés. Vérifiez votre accès Imagerie puis réessayez.' }
            finally { if (revision === this.revision) this.loading = false }
        },
        choose(event) {
            const files = Array.from(event.target.files || [])
            this.actionError = ''; this.message = ''; this.selected = []; this.key = ''
            if (files.length + this.files.length > 20 || files.some(f => f.size > 5 * 1024 * 1024 || (f.type && !types.includes(f.type)))) {
                this.actionError = 'Sélection refusée : JPEG, PNG, WebP ou PDF, 5 Mo par fichier et 20 clichés maximum par examen.'
                event.target.value = ''; return
            }
            this.selected = files
            if (files.length) this.key = batchKey()
        },
        async upload() {
            if (!this.selected.length || this.busy || !this.canEdit) return
            const revision = this.revision
            this.busy = true; this.actionError = ''; this.message = ''
            try {
                const data = await api.upload(this.examenId, this.selected, this.key)
                if (revision !== this.revision) return
                this.apply(data); this.selected = []; this.key = ''; this.$refs.files.value = ''
                this.message = 'Clichés enregistrés. Le compte rendu reste une étape distincte.'
                this.$emit('changed')
            } catch (error) {
                if (revision === this.revision) this.actionError = this.errorMessage(error, 'Enregistrement non confirmé. La sélection est conservée : réessayez sans la modifier pour éviter un doublon.')
            } finally { if (revision === this.revision) this.busy = false }
        },
        errorMessage(error, fallback) {
            const status = error.response && error.response.status
            if (status === 401 || status === 403) return 'Accès refusé ou expiré. Vérifiez votre session et vos affectations Imagerie.'
            if (status === 409) return 'Modification refusée : compte rendu existant, demande non validée en caisse ou lot déjà utilisé.'
            if (status === 413) return 'Le lot dépasse la limite du serveur. Réduisez le nombre de fichiers.'
            if (status === 422) return 'Fichiers refusés : vérifiez leur format réel, leur taille et la limite de 20 clichés.'
            return fallback
        },
        async open(file) {
            this.closePreview(); this.actionError = ''; this.previewBusy = true
            const revision = this.previewRevision
            try {
                const response = await api.content(this.examenId, file.id, this.dossier)
                if (revision !== this.previewRevision) return
                const mime = response.headers['content-type'] || response.data.type
                this.preview = { name: file.name, url: URL.createObjectURL(response.data), mime }
            } catch (error) {
                if (revision === this.previewRevision) this.actionError = this.errorMessage(error, 'Ce cliché est indisponible. Actualisez la galerie puis réessayez.')
            } finally { if (revision === this.previewRevision) this.previewBusy = false }
        },
        closePreview() {
            this.previewRevision++
            if (this.preview) URL.revokeObjectURL(this.preview.url)
            this.preview = null; this.previewBusy = false; this.zoom = 1
        },
        async confirmRemoval() {
            if (!this.removing || this.reason.trim().length < 3 || this.busy) return
            const revision = this.revision
            this.busy = true; this.actionError = ''
            try {
                const data = await api.remove(this.examenId, this.removing.id, this.reason.trim())
                if (revision !== this.revision) return
                this.apply(data); this.closePreview(); this.removing = null; this.reason = ''
                this.message = 'Cliché retiré de la galerie. Sa trace est conservée.'; this.$emit('changed')
            } catch (error) {
                if (revision === this.revision) this.actionError = this.errorMessage(error, 'Retrait non confirmé. Réessayez.')
            } finally { if (revision === this.revision) this.busy = false }
        },
        size(bytes) { return bytes == null ? 'Archive' : (bytes / 1024 / 1024).toFixed(2) + ' Mo' }
    }
}
